import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { useHistoryNew } from '@utils'
import { Icon } from '@cps'
import { cartMobx } from 'restaurant'
import { thirdPartyMobx } from '@mobxStore'
import '../CouponBar/index.scss'

interface IProps {
  /** 展示外部容器 */
  showWrap?: boolean;
}

const ThirdCouponBar: React.FC<IProps> = ({ showWrap = true }) => {
  const history = useHistoryNew()

  const handleGoThird = () => {
    history.push('/thirdCoupon')
  }

  // 是否支持核券
  const hasThird = useMemo(() => {
    return !!thirdPartyMobx.checkCanUseToChannelEatType
  }, [cartMobx.channel, cartMobx.info.eatType])

  if (!hasThird) return null

  const couponCnt = thirdPartyMobx.checkCoupons.length

  const ContentNode = () => (
    <div className='coupon-bar-element' data-cypid='click-third-coupon-bar' onClick={handleGoThird}>
      <div className='bt-icon'>
        <Icon name='thirdcoupon' />
      </div>
      <div className='name'>{couponCnt > 0 ? `x${couponCnt}` : i18n.t('pay.douyinCoupon')}</div>
    </div>
  )

  return showWrap ? (
    <div className='bt-fill-btn-wrap'>
      <div className='coupon-bar-element-wrapper'>
        <ContentNode />
      </div>
    </div>
  ) : (
    <ContentNode />
  )
}

export default observer(ThirdCouponBar)
